import React, { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import { getPieChartData } from "../../api/Api";
import { useNavigate } from "react-router-dom";

const DoughutData = () => {
    const navigate = useNavigate();
    const [pieChartData, setPieChartData] = useState({});

    const fetchPieChartData = async () => {
        try {
            const response = await getPieChartData();
            console.log("piee", response);
            if (response?.statusDescription?.status === 200) {
                setPieChartData({
                    serviceData: response.servicedata,
                    packageData: response.packageData
                });
            }
        } catch (error) {
            console.error('Error fetching pie chart data:', error);
        }
    };

    useEffect(() => {
        fetchPieChartData();
    }, []);

    // Handle chart click for both doughnuts
    const handleChartClick = (chart, elements, routes) => {
        if (elements.length > 0) {
            const clickedIndex = elements[0].index;
            const route = routes[clickedIndex];
            if (route) {
                navigate(route);
            }
        }
    };

    return (
        <div>
            <div className="charts-container mb-0">
                <div className="chart-card bar">
                    <h3 className="text-center">Service Status</h3>
                    <div className="chart-wrapper">
                        {pieChartData.serviceData && (
                            <Doughnut
                                style={{ width: "235px", height: "235px", marginLeft: "auto", marginRight: "auto", cursor: "pointer" }}
                                data={{
                                    ...pieChartData.serviceData,
                                    datasets: [{
                                        ...pieChartData.serviceData.datasets[0],
                                        backgroundColor: pieChartData.serviceData.datasets[0].backgroundColor.map(color => {
                                            switch (color) {
                                                case 'text-warning':
                                                    return '#ffc107';
                                                case 'text-success':
                                                    return '#28a745';
                                                case 'text-danger':
                                                    return '#dc3545';
                                                case 'text-primary':
                                                    return '#007bff';
                                                default:
                                                    return color;
                                            }
                                        })
                                    }]
                                }}
                                options={{
                                    plugins: {
                                        legend: {
                                            position: 'bottom'
                                        },
                                        title: {
                                            display: true,
                                            text: 'TestBed vs Production'
                                        }
                                    },
                                    onClick: (event, elements) => {
                                        handleChartClick(event, elements, pieChartData.serviceData.datasets[0].route);
                                    }
                                }}
                            />
                        )}
                    </div>
                </div>

                <div className="chart-card bar">
                    <h3 className="text-center">Package Status</h3>
                    <div className="chart-wrapper">
                        {pieChartData.packageData && (
                            <Doughnut
                                style={{ width: "235px", height: "235px", marginLeft: "auto", marginRight: "auto", cursor: "pointer" }}
                                data={{
                                    ...pieChartData.packageData,
                                    datasets: [{
                                        ...pieChartData.packageData.datasets[0],
                                        backgroundColor: [
                                            '#28a745',  // Active - green
                                            '#dc3545',  // InActive - red
                                            '#17a2b8',  // totalRevenue - blue
                                            '#ffc107',  // partnerShare - yellow
                                            '#6610f2',  // aggregatorShare - purple
                                            '#fd7e14',  // qanawatShare - orange
                                            '#20c997'   // mobisoftShare - teal
                                        ]
                                    }]
                                }}
                                options={{
                                    plugins: {
                                        legend: {
                                            position: 'bottom'
                                        },
                                        title: {
                                            display: true,
                                            text: 'Package Distribution'
                                        }
                                    },
                                    onClick: (event, elements) => {
                                        handleChartClick(event, elements, pieChartData.packageData.datasets[0].route);
                                    }
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DoughutData;